import { renderPipeline } from "./main.tsx";

window.renderPipeline = renderPipeline;
